function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
  
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
  	if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }


  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener); 
    
class IshiModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'ISHIMODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.classList.add("active");
    document.querySelector('.newsletter-popup-overlay')? document.querySelector('.newsletter-popup-overlay').classList.add("active") : '';
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.classList.remove("active");
    document.querySelector('.newsletter-popup-overlay')? document.querySelector('.newsletter-popup-overlay').classList.remove("active") : '';
    this.openedBy.setAttribute("aria-expanded","false");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    if(this.getAttribute("id") == "PopupModal-newsletter"){
      if($('.dono-show-check').prop("checked") == true) {
        setTheCookie("customer_posted", "true", 14);
      }
  	}
  }
}
customElements.define('ishimodal-dialog', IshiModalDialog);

class IshiModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('.ishi-popup-modal__button');
    if (!button) return;
        button.addEventListener('click', () => {
          const modal = document.querySelector(this.getAttribute('data-modal'));
          if (modal) modal.show(button);
    });
  }
}
customElements.define('ishimodal-opener', IshiModalOpener);

class QuickviewDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'QUICKVIEW-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.classList.add("active");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.classList.remove("active");
    this.querySelector(".qv-wrapper").classList.add("loading");
    this.openedBy.setAttribute("aria-expanded","false");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('quickview-dialog', QuickviewDialog);

class QuickviewOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('.product-popup-modal__button');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('quickview-opener', QuickviewOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
     window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
    var rtlFlag = $("body").hasClass("lang-rtl") ? true : false;
  if ((rtlFlag = true)) {
    if (this.currentPage === 1) {
      this.prevButton.removeAttribute("disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }
  }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.doIshiTasks();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
//     const parent = newMedia.parentElement;
//     parent.prepend(newMedia);
//     window.setTimeout(() => { parent.scroll(0, 0) });
       document.getElementById('main-media-container').innerHTML = "";
       document.getElementById('main-media-container').prepend(newMedia.cloneNode(true));
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }
  
  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  doIshiTasks() {
	var variant = this.currentVariant;
    var skuTarget = document.querySelector(".variant-sku");
	if (typeof(skuTarget) != 'undefined' && skuTarget != null) {
		document.querySelector(".variant-sku").innerHTML = variant.sku;
	}
    if (document.getElementsByClassName("ishi-progress-content").length) {
	  var stock = 0;
      var variantSpan =  document.getElementById("variant-" + variant.id);
      if (typeof(variantSpan) != 'undefined' && variantSpan != null)
      {
      	stock = parseInt(variantSpan.getAttribute("data-stock"));
      }
      var maxqty = parseInt(document.getElementsByClassName("ishi-progress-content")[0].getAttribute("data-quantity"));
	  document.getElementById("variant-stock").innerHTML = stock;
      if(stock > 0 && stock <= maxqty) {
        document.getElementsByClassName("ishi-progress-content")[0].classList.remove("hidden");
		var progressSpan =  document.getElementById("ishi-progress-bar").getElementsByTagName("span")[0];
		switch(stock){case 9:progressSpan.style.width = "65%";break;case 8:progressSpan.style.width = "60%";break;case 7:progressSpan.style.width = "55%";break;case 6:progressSpan.style.width = "50%";break;case 5:progressSpan.style.width = "45%";break;case 4:progressSpan.style.width = "30%";break;case 3:progressSpan.style.width = "20%";break;case 2:progressSpan.style.width = "10%";break;case 1:progressSpan.style.width = "5%";break;default:progressSpan.style.width = "90%";}
     } else {
         document.getElementsByClassName("ishi-progress-content")[0].classList.add("hidden");
      }
	} 

  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


function setTheCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
    
function getTheCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
    
function eraseTheCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
 
function setupWishlistButtons() {
  if(getTheCookie("wishlist") != null && getTheCookie("wishlist") != '__' && getTheCookie("wishlist") != '') {
      var str = String(getTheCookie("wishlist")).split("__");
      for (var i=0; i<str.length; i++) {
        if (str[i] != '') {
          (document.querySelector('.added-wishbutton-'+str[i]) != null) ? document.querySelector('.added-wishbutton-'+str[i]).style.display = "block" : '';
          (document.querySelector('.default-wishbutton-'+str[i]) != null) ? document.querySelector('.default-wishbutton-'+str[i]).remove() : '';
          (document.querySelector('.loadding-wishbutton-'+str[i]) != null) ? document.querySelector('.loadding-wishbutton-'+str[i]).remove() : '';
        }
      }
  }
}
function setGridLayout() {
  if(!document.querySelectorAll("#ProductGridContainer").length)return;
  var gridCookie = getTheCookie('collectiongrid-layout');
  if(document.querySelectorAll("[data-id='" + gridCookie + "']").length) {
    document.querySelectorAll(".collectiongrid-layout").forEach((element) => {
    	element.classList.remove("active");
    });
  } else {
    gridCookie = document.querySelector(".collectiongrid-layout.grid-layout-default").getAttribute("data-id");
    setTheCookie("collectiongrid-layout", gridCookie, 14);
  }  
  var classNames = document.querySelector("[data-id='" + gridCookie + "']").classList;
  document.querySelector("[data-id=" + gridCookie + "]").classList =  classNames + " active";
  document.getElementById("product-grid").querySelectorAll('li').forEach((element) => {
    element.className = document.querySelector("[data-id=" + gridCookie + "]").getAttribute("data-class");
  }); 
  
  //list-view has the buttons and grid-view has been selected
  if((gridCookie == "collectiongrid-layout-2" || gridCookie == "collectiongrid-layout-3" || gridCookie == "collectiongrid-layout-4") && document.getElementById("product-grid").querySelectorAll('li .card-information__wrapper .thumbnail-buttons').length) {
    document.getElementById("product-grid").querySelectorAll('li').forEach((element) => {
      var node = element.querySelector(".thumbnail-buttons");
      node.parentElement.removeChild(node);
      element.querySelector(".card__inner").append(node);  
  	});
  }  
  //grid-view has the buttons and listview has been selected
  if((gridCookie == "collectiongrid-layout-1") && document.getElementById("product-grid").querySelectorAll('li .card__inner .thumbnail-buttons').length) {
  	document.getElementById("product-grid").querySelectorAll('li').forEach((element) => {
      var node = element.querySelector(".thumbnail-buttons");
      node.parentElement.removeChild(node);
      element.querySelector(".card-information__wrapper").append(node);  
  	});
  }
  document.querySelector('#shopify-section-Ishi_sidebar')? gridCookie += " with-sidebar" : '';
  document.getElementById("ProductGridContainer").className = gridCookie;
}
//cart upsell carousell function
        function cartUpsellCarousel(){
          var rtlFlag = ($('body').hasClass('lang-rtl')) ? true : false;

          $('#cart-notification-slider').owlCarousel({
            nav: false,
            navText: [
              '<i class=\'fa fa-angle-left\'></i>',
              '<i class=\'fa fa-angle-right\'></i>'
            ],
            dots: true,
            autoplay:false,
            loop: true,
            items: 1,
            margin:15,
            rewind:false,
            rtl:rtlFlag,
          });
        }  

 function addToCartJS(qty,variantID, btn) {   
  var xhr = new XMLHttpRequest();
  var url = "/cart/add.js";
  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      buttonTextChange();
        var parsedState = JSON.parse(xhr.responseText);
        if(document.querySelector(".ajax-cart-disabled")) window.location = "/cart";
        document.querySelector('cart-notification').renderContents(parsedState);
        btn.classList.remove("loading");
        openCartDrawer();
    }
  };
  var sectionsToRender = ["cart-notification-product", "cart-notification-button", "cart-icon-bubble", "cart-upsell", "cart-drawer-gift"];
  var sections_url = window.location.pathname;
  var data = JSON.stringify({"quantity": qty, "id": variantID, "sections" : sectionsToRender, "sections_url" : sections_url });
  xhr.send(data);
  }

function removeFromCartJS(variantID) {
  var xhr = new XMLHttpRequest();
  var url = "/cart/change.js";
  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      buttonTextChange();
        var parsedState = JSON.parse(xhr.responseText);
        if(document.querySelector(".ajax-cart-disabled")) window.location = "/cart";
        document.querySelector('cart-notification').renderContents(parsedState);
      cartUpsellCarousel(); 
    }
  };
  var sectionsToRender = ["cart-notification-product", "cart-notification-button", "cart-icon-bubble"];
  var sections_url = window.location.pathname;
  var data = JSON.stringify({"quantity": 0, "id": variantID, "sections" : sectionsToRender, "sections_url" :sections_url });
  xhr.send(data);
}

function updateCartItemJS(qty, variantID) {
  var xhr = new XMLHttpRequest();
  var url = "/cart/change.js";
  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
        var parsedState = JSON.parse(xhr.responseText);
        if(document.querySelector(".ajax-cart-disabled")) window.location = "/cart";
        document.querySelector('cart-notification').renderContents(parsedState);
      cartUpsellCarousel(); 
    }
  };
  var sectionsToRender = ["cart-notification-product", "cart-notification-button", "cart-icon-bubble", "cart-upsell", "cart-drawer-gift"];
  var sections_url = window.location.pathname;
  var data = JSON.stringify({"quantity": qty, "id": variantID, "sections" : sectionsToRender, "sections_url" :sections_url });
  xhr.send(data);
}

function convertToMoney(price) {
  var price = parseFloat(price / 100).toFixed(2);
  var currency = document.getElementsByTagName("html")[0].getAttribute("currency");
  return currency + price; 
}

function setCountDownTimer(date,target) {
  var t = date.split(/[- :]/);
  var d = new Date(t[0], t[1]-1, t[2], t[3], t[4], t[5]);
  var countDownDate = new Date(d);
  setInterval(function() {
    var now = new Date().getTime();
    var distance = countDownDate - now;
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    // Display the result in the element with id="demo"
   // target.getElementsByClassName("countdown-days")[0].innerHTML = date;
    target.getElementsByClassName("countdown-days")[0].innerHTML = days < 10 ? "0" + days : days;
    target.getElementsByClassName("countdown-hours")[0].innerHTML = hours < 10 ? "0" + hours : hours;
    target.getElementsByClassName("countdown-minutes")[0].innerHTML = minutes < 10 ? "0" + minutes : minutes;
    target.getElementsByClassName("countdown-seconds")[0].innerHTML = seconds < 10 ? "0" + seconds : seconds;
  }, 1000);
}
function openCartDrawer() {   
  document.querySelector('.cart-notification').classList.add("active");
  document.querySelector('.cart-overlay').classList.add("active");
  document.body.classList.add('cart-overflow');
  cartUpsellCarousel(); 
}

function closeCartDrawer() {   
  document.querySelector('.cart-notification').classList.remove("active");
  document.querySelector('.cart-overlay').classList.remove("active");
  document.body.classList.remove('cart-overflow');
}
    //Motivator Product JS Start
var motivatorProduct = false;
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target.classList.contains('click_gift')) {
      var isChecked = target.checked;
      fetch('/cart.json')
        .then(response => response.json())
        .then(data => {
          var items = data.items;
          var foundMotivatorProduct = items.some(item => item.handle === motivatorProductHandle);
          if (isChecked && !foundMotivatorProduct) {
            addMotivatorProduct(motivatorProductVariantID);
          } else if (!isChecked) {
            removeMotivatorProduct(motivatorProductVariantID);
          }
          target.closest('.cart_loading').classList.add('cart_loading');
        });
    }
  });

  function cartItemCheck() {
    fetch('/cart.json')
      .then(response => response.json())
      .then(data => {
        var items = data.items;
        if (items.length > 1) {
          removeMotivatorProduct(motivatorProductVariantID);
          document.querySelector('.click_gift').checked = false;
        }
      });
  }

  function initMotivatorProduct() {
    fetch('/cart.json')
      .then(response => response.json())
      .then(data => {
        var items = data.items;
        var foundMotivatorProduct = items.some(item => item.handle === motivatorProductHandle);
        if (!foundMotivatorProduct) {
          addMotivatorProduct(motivatorProductVariantID);
        }
      });
  }
});


function addMotivatorProduct(motivatorProductVariantID) {
    var xhr = new XMLHttpRequest();
    var url = "/cart/add.js";
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        var parsedState = JSON.parse(xhr.responseText);
        if(document.querySelector(".ajax-cart-disabled")) window.location = "/cart";
        document.querySelector('cart-notification').renderContents(parsedState);
        $(".click_gift").prop("checked", true);
        cartUpsellCarousel();
      }
    };
    var sectionsToRender = ["cart-notification-product", "cart-notification-button", "cart-icon-bubble", "cart-upsell", "cart-drawer-gift"];
    var sections_url = window.location.pathname;
    var data = JSON.stringify({"quantity": 1, "id": motivatorProductVariantID, "sections" : sectionsToRender, "sections_url" : sections_url });
  
    xhr.send(data);
}

function removeMotivatorProduct(motivatorProductVariantID) {
    var xhr = new XMLHttpRequest();
    var url = "/cart/change.js";
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        var parsedState = JSON.parse(xhr.responseText);
        if(document.querySelector(".ajax-cart-disabled")) window.location = "/cart";
        document.querySelector('cart-notification').renderContents(parsedState);
        $(".click_gift").prop("checked", false);
        cartUpsellCarousel();
      }
    };
    var sectionsToRender = ["cart-notification-product", "cart-notification-button", "cart-icon-bubble", "cart-upsell", "cart-drawer-gift"];
    var sections_url = window.location.pathname;
    var data = JSON.stringify({"quantity": 0, "id": motivatorProductVariantID, "sections" : sectionsToRender, "sections_url" :sections_url });
    xhr.send(data);
}
//Motivator Product JS END